<div class="fixed inset-0 flex items-center justify-center">
  <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-yellow-900"></div>
</div>